import { decodeHTMLEntities } from "helpers/functions/commons";

export const HTML_SYMBOLS = {
    space: decodeHTMLEntities('&nbsp')
}